<app-chart-mini-donut
	[doNotShowChartPlaceholder]="doNotShowChartPlaceholder"
	[chartData]="chartData"
	[diameter]="diameter"
	[captionKey]="data.captionKey"
	[isSorting]="false"
	[hasTooltips]="false"
	[centerValue]="percentageView">
</app-chart-mini-donut>
